// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"d0d41d0a","228":"9a8d47dc","272":"8ec62dfe","287":"80b91a0f","352":"90a07f4a","549":"754ac649","666":"b2c655b9","816":"1832009c","837":"348ce62f","930":"5b398b50"}[chunkId] + ".chunk.js";
};